import {Component, ElementRef, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {DraftService} from "../service/save-draft/save-draft.service";
import {NasabahModel} from "../service/model/dashboard.model";
import {DownloadDocumentService} from "../service/download-document/download-document.service";

@Component({
  selector: 'app-endorse-final',
  templateUrl: './endorse-final.component.html',
  styleUrls: ['./endorse-final.component.css']
})
export class EndorseFinalComponent {

  todayDate : string = new Date().toISOString()
  dataDashboard: any;
  tandaTangan: any;
  login: any;
  endorseResponse: any;

  @ViewChild('btnAcceptance')
  btnAcceptance!: ElementRef;

  constructor(private route: Router,
              private draftService: DraftService,
              private documentService: DownloadDocumentService) {
    let background = document.getElementById("background");
    if (background != null) {
      background.className = "allianz-background-faded"
    }

    let jsonLogin = sessionStorage.getItem('login')

    if (jsonLogin) {
      this.login = JSON.parse(jsonLogin);
    }

    let jsonDataDashboard = localStorage.getItem("selected-item")
    if (jsonDataDashboard) {
      this.dataDashboard = JSON.parse(jsonDataDashboard);
    }

    let jsonEndorse = localStorage.getItem('endorsement-response')
    if(jsonEndorse) {
      this.endorseResponse = JSON.parse(jsonEndorse);
    }


    // this.getDraftCover1()
    // this.getDraftCover2()
    // this.getDraftCover3()

  }



  toSpajkRiplay() {
    let nasabah: NasabahModel = {
      nasabahUw: {},
      nasabahNewCovering: {},
      nasabahCalculator: {}
    };
    let jsonNasabah = localStorage.getItem("nasabah")
    if (jsonNasabah) {
      nasabah = JSON.parse(jsonNasabah)
    }
    localStorage.setItem("from-dashboard", "true")
    localStorage.setItem("new-covering-response", JSON.stringify({
      premiData: JSON.stringify({
        netPremi: nasabah.nasabahNewCovering.standardPremi
      })
    }))
    this.route.navigate(['eform/spajk-riplay'])
  }

  backToMenu() {
    this.route.navigate(['eform/menu'])
  }

  backToDashboard() {
    this.route.navigate(['eform/dashboard'])
  }

  downloadAkseptasi() {
    this.documentService.downloadDocument({
      referenceNo: this.dataDashboard.referenceNo,
      docType: "ACCEPTANCE"
    }).subscribe(res => {
      this.btnAcceptance.nativeElement.download = 'Surat Akseptasi ' + this.dataDashboard.referenceNo + '.pdf'
      this.btnAcceptance.nativeElement.href = 'data:application/octet-stream;base64,' + res.document;
      this.btnAcceptance.nativeElement.click()
    })
  }
}
